import Base from "@/controllers/base";
export default class Observer extends Base {
  constructor() {
    super();
    this.forms = document.querySelectorAll("form.observe-form");
    this.iterateForms();
  }

  iterateForms() {
    if (this.forms.length === 0) return;
    this.forms.forEach((form) => {
      if (form.hasAttribute("observer-handler")) return;
      form.setAttribute("observer-handler", true);
      this.observeForm(form, async (target) => {
        const method = (
          form.dataset.method ||
          form.method ||
          "GET"
        ).toUpperCase();
        const url = form.dataset.url || form.action;
        const formData = new FormData(form);
        formData.append("changed", target.id);
        let response = null;
        if (method == "GET") {
          response = await fetch(url + "?" + new URLSearchParams(formData), {
            method: method,
            headers: {
              Accept: "text/vnd.turbo-stream.html",
              "X-CSRF-Token": this.authenticityToken,
            },
          });
        } else {
          response = await fetch(url, {
            method: method,
            headers: {
              Accept: "text/vnd.turbo-stream.html",
              "X-CSRF-Token": this.authenticityToken,
            },
            body: formData,
          });
        }
        let text = await response.text();
        Turbo.renderStreamMessage(text);
        NApp.dispatchTurboLoad();
      });

      if (form.classList.contains("observe-init")) {
        form.dispatchEvent(new Event("change"));
      }
    });
  }

  observeForm(form, callback) {
    form.addEventListener("change", (event) => {
      const target = event.target;
      if (target == form || !target.classList.contains("unobservable")) {
        callback(target);
      }
    });
  }

  serialize(data) {
    let obj = {};
    for (let [key, value] of data) {
      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]];
        }
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    }
    return obj;
  }
}

document.addEventListener("turbo:load", () => {
  setTimeout(() => new Observer(), 250);
});
